module.exports = function () {
  // GameCardfan owns the #cardfan node; Poker only provides the stable mount.
  return "";
};